import React from 'react';

export default ({type, className}) => (
  <div className={`upload-badge ${className}` || ''}>
    {type}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/admin/data-import/upload-history-badge.jsx